import { mv } from './modules/mv';
import { hamburger } from './modules/hamburger';
import { smooth } from './modules/smooth';
import { tab } from './modules/tab';
import { scrollmagic } from './modules/scrollmagic';
import { scrollAction } from './modules/scrollAction';
mv();
hamburger();
smooth();
tab();
scrollmagic();
scrollAction();
